import { CaretDown, Check, List as MenuIcon } from "@phosphor-icons/react";
import { useEffect, useRef, useState } from "react";

export default function Tabs({ tabs, active, onChange, testid = "tabs" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  const activeTab = tabs.find((t) => t.key === active) || tabs[0];

  return (
    <div data-testid={testid}>
      {/* Mobile: dropdown */}
      <div className="md:hidden relative" ref={ref}>
        <button
          type="button"
          data-testid={`${testid}-mobile-toggle`}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          className="w-full flex items-center justify-between px-5 py-5 border-2 font-semibold"
          style={{
            borderColor: "var(--invert-bg)",
            background: "var(--invert-bg)",
            color: "var(--invert-text)",
          }}
        >
          <span className="flex items-center gap-3">
            <MenuIcon size={22} weight="bold" style={{ color: "var(--invert-text)" }} />
            <span className="title-xl text-xl">{activeTab?.label}</span>
            {typeof activeTab?.count === "number" && (
              <span className="label" style={{ color: "var(--invert-text)", opacity: 0.6 }}>· {activeTab.count}</span>
            )}
          </span>
          <CaretDown size={18} weight="bold" className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
        {open && (
          <div
            data-testid={`${testid}-mobile-menu`}
            className="absolute left-0 right-0 mt-1 z-30 border-2 shadow-2xl"
            style={{
              borderColor: "var(--invert-bg)",
              background: "var(--invert-bg)",
              color: "var(--invert-text)",
            }}
          >
            {tabs.map((t) => {
              const isActive = t.key === active;
              return (
                <button
                  key={t.key}
                  data-testid={`tab-${t.key}-mobile`}
                  onClick={() => { onChange(t.key); setOpen(false); }}
                  className="w-full flex items-center justify-between px-5 py-5 text-left font-semibold text-base tracking-wide"
                  style={{
                    background: isActive ? "var(--invert-text)" : "transparent",
                    color: isActive ? "var(--invert-bg)" : "var(--invert-text)",
                    borderBottom: "1px solid rgba(127,127,127,0.25)",
                  }}
                >
                  <span className="flex items-center gap-3">
                    <span className="uppercase text-base">{t.label}</span>
                    {typeof t.count === "number" && (
                      <span className="text-sm opacity-60">({t.count})</span>
                    )}
                  </span>
                  {isActive && <Check size={16} weight="bold" />}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* Desktop: horizontal tabs */}
      <div
        className="hidden md:flex flex-wrap items-center gap-1 border-b overflow-x-auto"
        style={{ borderColor: "var(--hair)" }}
      >
        {tabs.map((t) => {
          const isActive = t.key === active;
          return (
            <button
              key={t.key}
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(t.key)}
              data-testid={`tab-${t.key}`}
              className="tab-btn whitespace-nowrap"
            >
              {t.label}
              {typeof t.count === "number" && (
                <span
                  className="ml-2 text-xs"
                  style={{ color: isActive ? "var(--text)" : "var(--text-dim)", opacity: isActive ? 0.7 : 1 }}
                >
                  ({t.count})
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
